
class DocumentType {
  constructor () {
    this.id = null
    this.name = null
  }

  toString () {
    return `DocumentType{id=${this.id}, name='${this.name}'}`
  }
}
export default DocumentType
